const googleAnalytics = (data) => {
  window.dataLayer.push(data);
};

export default googleAnalytics;
